import type { FC } from 'react'

import { PillButton } from '@/components/generals/pill-button'
import { BoardImage } from '@/components/generals/board-image'
import { enquirySection, studio } from '@/constants/dentea'

/** Shared pre-footer enquiry block. Appears on every page except /contact. */
export const AppointmentSection: FC = () => {
    return (
        <section id='start-a-project' aria-labelledby='enquiry-heading' className='w-full'>
            <div className='flex w-full flex-col bg-paper lg:min-h-screen lg:flex-row'>
                <div className='flex w-full flex-col items-center justify-between gap-16 px-6 py-24 lg:w-1/2 lg:px-20 lg:pt-30 lg:pb-20'>
                    <div className='flex flex-col items-center gap-4 text-center'>
                        <p data-anim='rise' className='label text-ink/60'>
                            {enquirySection.label}
                        </p>

                        <h2
                            id='enquiry-heading'
                            data-anim='lines'
                            className='display max-w-[400px] text-[2rem] opacity-0 md:text-[2.5rem] lg:text-[3.5rem]'
                            style={{ lineHeight: '0.9em' }}
                        >
                            {enquirySection.headline.join(' ')}
                        </h2>

                        <p data-anim='rise' data-anim-delay='0.1' className='label max-w-[300px] text-ink/60'>
                            {enquirySection.body}
                        </p>

                        <div
                            data-anim='rise'
                            data-anim-delay='0.18'
                            className='flex w-full flex-col items-stretch gap-4 pt-10 sm:w-auto sm:flex-row sm:items-center'
                        >
                            <PillButton href={enquirySection.primary.href} size='lg' className='justify-center'>
                                {enquirySection.primary.label}
                            </PillButton>

                            <PillButton
                                href={enquirySection.secondary.href}
                                variant='outline'
                                arrow='none'
                                size='lg'
                                external
                                className='justify-center'
                            >
                                {enquirySection.secondary.label}
                            </PillButton>
                        </div>
                    </div>

                    <ul data-anim-group data-anim-stagger='0.08' className='flex w-full flex-col gap-2.5 xl:flex-row'>
                        {enquirySection.chips.map((chip) => (
                            <li
                                key={chip}
                                className='relative flex h-40 flex-1 items-end justify-end rounded-2xl bg-ink/6 p-6'
                            >
                                <span aria-hidden='true' className='absolute top-4 left-4 size-2 rounded-full bg-ink' />

                                <span className='serif-body text-right text-[1.3rem]'>{chip}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div data-anim='mask' className='relative h-75 w-full overflow-hidden rounded-2xl bg-charcoal lg:h-auto lg:flex-1'>
                    <BoardImage data-anim-inner tile={studio.enquiryImage} className='absolute inset-0 size-full' />
                </div>
            </div>
        </section>
    )
}
